export default "__VITE_ASSET__D2Kclri5__"